'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.run(function ($ionicPlatform, $rootScope, $ionicHistory, $timeout, $state, $location, clientInfo, jAlert, session, EVENTS, USER_ROLES) {

    $ionicPlatform.ready(function () {});

    /**
     * 在浏览历史栈中移除当前的视图
     * 用于在跳转到新视图前
     * 类似 window.location.replace
     */
    $rootScope.removeCurrentHistory = function () {
      $ionicHistory.currentView($ionicHistory.backView());
    };

    /**
     * 返回上一页 用于页面回退 且避免留下历史记录
     * 覆盖 $ionicGoBack
     */
    $rootScope.goBack = $rootScope.$ionicGoBack = function () {
      window.history.back();
    };

    /**
     * 跳转到固定的视图 统一入口
     */
    $rootScope.goHome = function () {
      // 待跳转过去的视图名称
      var stateName = 'home';
      var authorized = session.isAuthorized($rootScope.geAuthorizedRoles(stateName));
      if (!authorized.permissible) {
        $state.go('login', null, { location: 'replace' });
      } else {
        var returnUrl = window.localStorage.getItem('returnUrl');
        if (returnUrl && returnUrl != '/login') {
          $state.go(stateName, null, { location: 'replace' });
          if (returnUrl != '/' + stateName) {
            $timeout(function () {
              $location.path(returnUrl);
              window.localStorage.removeItem('returnUrl');
            }, 300);
          }
        } else if ($rootScope.returnUrl && $rootScope.returnUrl.name !== 'login') {
          // 重定向到returnUrl 登录成功后 跳转到原来的页面
          $timeout(function () {
            $rootScope.removeCurrentHistory();
            $state.go($rootScope.returnUrl.name, $rootScope.returnUrl.params, { location: 'replace' });
            $rootScope.returnUrl = null;
          }, 300);
        } else {
          if ($ionicHistory.backView()) {
            $ionicHistory.goBack();
          } else {
            $state.go(stateName, null, { location: 'replace' });
          }
        }
      }
    };

    /**
     * 获取指定视图的 AuthorizedRoles
     */
    $rootScope.geAuthorizedRoles = function (state) {
      var stateObj = $state.get(state);
      if (stateObj) {
        if (stateObj.data && stateObj.data.authorizedRoles) {
          return stateObj.data.authorizedRoles;
        }
      }
      return null;
    };

    /**
     * 监听视图跳转 用于授权认证
     */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {

      // 指示stateChange动作是否已阻止
      $rootScope.stateChangePrevented = false;

      if (toState && toState.data) {

        // 检测 toState 是否处于建设中
        var inConstruction = toState.data.inConstruction;
        if (inConstruction) {
          jAlert.showOnce({ message: '亲，这个模块正在建设中，请耐心等待...' });
          event.preventDefault();
          return;
        }

        // 检测当前角色是否拥有权限访问 toState
        var authorized = session.isAuthorized($rootScope.geAuthorizedRoles(toState.name));
        if (!authorized.permissible) {
          // 若 toState 需要登录的权限 则跳转到登录界面
          if (authorized.unauthorizedRoles.indexOf(USER_ROLES.common) > -1) {
            $rootScope.returnUrl = { name: toState.name, params: toParams };
            $state.go('login');
          } else {
            $rootScope.$broadcast(EVENTS.notAuthorized);
            jAlert.showOnce({ message: '无法访问未授权的界面' });
          }
          $rootScope.stateChangePrevented = fromState && fromState.name === 'login';
          event.preventDefault();
        }
      }
    });
  });
  app.constant('$ionicLoadingConfig', {
    template: '<ion-spinner icon="android"></ion-spinner>',
    hardwareBackButtonClose: true,
    animation: 'fade-in',
    noBackdrop: true,
    delay: 200
  });
};

; /**
   * APP run
   * 在注入器创建之后被执行 应用中第一个被执行的方法
   * 用于注册全局的事件监听器
   * 用于验证用户的权限等
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/app.run.js
// module id = 35
// module chunks = 0